"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIAL_BALANCE_RESPONSE_EXAMPLE = exports.ACCOUNT_LEDGER_RESPONSE_EXAMPLE = void 0;
exports.ACCOUNT_LEDGER_RESPONSE_EXAMPLE = {
    accountId: '44444444-4444-4444-8444-444444444444',
    accountCode: '1100',
    accountName: 'Cash',
    accountType: 'ASSET',
    openingBalance: 0,
    closingBalance: 5000000,
    entries: [
        {
            journalEntryId: '11111111-1111-4111-8111-111111111111',
            entryNumber: 'JV-2026-000001',
            entryDate: '2026-07-20',
            entryType: 'POSTED',
            drOrCr: 'DEBIT',
            amount: 5000000,
            narration: null,
            runningBalance: 5000000,
        },
    ],
};
exports.TRIAL_BALANCE_RESPONSE_EXAMPLE = {
    asOfDate: '2026-07-20',
    rows: [
        { accountId: '44444444-4444-4444-8444-444444444444', accountCode: '1100', accountName: 'Cash', accountType: 'ASSET', debit: 5000000, credit: 0 },
        { accountId: '55555555-5555-4555-8555-555555555555', accountCode: '5100', accountName: 'Rent Expense', accountType: 'EXPENSE', debit: 0, credit: 5000000 },
    ],
    totalDebit: 5000000,
    totalCredit: 5000000,
    balanced: true,
};
//# sourceMappingURL=financial-general-ledger.response.js.map